const Getters = {
  // 備考定型分
  getNotePhraseListFromState: (state) => {
    return state.notePhraseList
  },
  getMaxSortNumber: (state) => {
    return state.maxSortNumber
  }
}

export default Getters
